import RadioItem from './radio-item.vue'

export default RadioItem
